
import React, { useEffect, useRef } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { motion } from "framer-motion"
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { AvForm, AvField, AvGroup, AvInput, AvFeedback, AvRadioGroup, AvRadio, AvCheckboxGroup, AvCheckbox } from 'availity-reactstrap-validation';
import { Pagination, Autoplay, Navigation, Keyboard } from 'swiper/modules';
// import WOW from 'wowjs';

import CountUp from 'react-countup';
import { Button, Label } from 'reactstrap';
import { Parallax, useParallax } from 'react-scroll-parallax';
import Inquiry from '../component/Inquiry';
import Whychooseus from '../component/Whychooseus';
import Loaction from '../component/Loaction';
export default function PrivacyPolicy() {
    const swiperRef1 = useRef();

    const parallax = useParallax < HTMLDivElement > ({
        rotateY: [0, 360],
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            {/* <section className='inner-banner'>
                <h1 className='heading'>Privacy Policy</h1>
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li className="breadcrumb-item"><a href="#">Home</a></li>
                        <li className='star'><i class="fa-solid fa-star-of-life"></i></li>
                        <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                    </ol>
                </nav>
            </section> */}

            <section className='padding_top privacy_po bottom padding-left-right about-section-1' style={{ background: 'rgb(15, 23, 42)' }}>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-2'></div>
                        <div className='col-lg-8'>
                            <h3 className='policy-heading'>
                                1. Terms
                            </h3>
                            <p className='policy-para'>
                                By accessing this web site, you are agreeing to be bound by these
                                web site Terms and Conditions of Use, all applicable laws and regulations,
                                and agree that you are responsible for compliance with any applicable local
                                laws. If you do not agree with any of these terms, you are prohibited from
                                using or accessing this site. The materials contained in this web site are
                                protected by applicable copyright and trade mark law.
                            </p>

                            <h3 className='policy-heading'>
                                2. Use License
                            </h3>


                            <p className='policy-para'>
                                By accessing this web site, you are agreeing to be bound by these
                                web site Terms and Conditions of Use, all applicable laws and regulations,
                                and agree that you are responsible for compliance with any applicable local
                                laws. If you do not agree with any of these terms, you are prohibited from
                                using or accessing this site. The materials contained in this web site are
                                protected by applicable copyright and trade mark law.
                            </p>

                            <h3 className='policy-heading'>
                                Privacy Policy
                            </h3>

                            <p className='policy-para'>
                                Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to understand how we collect, use, communicate and disclose and make use of personal information. The following outlines our privacy policy.
                            </p>

                            <h3 className='policy-heading'>
                                2. Use License
                            </h3>

                            <p className='policy-para'>
                                We are committed to conducting our business in accordance with these principles in order to ensure that the confidentiality of personal information is protected and maintained.
                            </p>
                        </div>
                        <div className='col-lg-2'></div>
                    </div>
                </div>
            </section>

        </>
    )
}
